import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store/store'
import {auth} from './firebase/firebaseConfig'
import LazyLoadDirective from './components/mixins/LazyLoadDirective'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faInstagram  } from '@fortawesome/free-brands-svg-icons'

import {
  faSignOutAlt,
  faTrashAlt,
  faMinus,
  faPlus,
  faTimes} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faSignOutAlt,
  faTrashAlt,
  faInstagram,
  faPlus,
  faMinus,
  faTimes)

Vue.component('font-awesome-icon', FontAwesomeIcon)
// Vue.component('font-awesome-layers', FontAwesomeLayers)
// Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
Vue.config.productionTip = false

Vue.config.productionTip = false

Vue.directive('lazyload', LazyLoadDirective);
let app = ''
auth.onAuthStateChanged((user) => {
  if (user) {
    let loggedInUser = {
      name: user.displayName,
      email: user.email,
      uid: user.uid
    }
    store.commit('setUser', loggedInUser)
  }
  // console.log('auth.currentUser.providerData', auth.currentUser.providerData)
  if(!app) {
    app = new Vue({
      store,
      router,
      el: '#app',
      render: h => h(App)
    })
  }
})
